import script from "./GoTop.vue?vue&type=script&setup=true&lang=js"
export * from "./GoTop.vue?vue&type=script&setup=true&lang=js"

import "./GoTop.vue?vue&type=style&index=0&id=4fda883a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fda883a"]])

export default __exports__